import { createService } from "@/Services/BaseService";

const ForretningService = createService("Forretning");

export function getDatabaseDisplayNames() {
  return ForretningService.get("/GetDatabaseDisplayNames");
}

// forceUpdate is accepted for a uniform call signature with the cached stats
// services (these are not cached). databaseDisplayName, when set, scopes the
// stats to a single database; left blank the backend aggregates every database
// the user can access (correct for single-database users).
export function getAllProcessRoiStats(startDate, endDate, forceUpdate = false, databaseDisplayName) {
  return ForretningService.getWithDateRange("/AllProcessRoiWithStats", startDate, endDate, {}, { databaseDisplayName });
}

export function getAllQueueRoiStats(startDate, endDate, forceUpdate = false, databaseDisplayName) {
  return ForretningService.getWithDateRange("/AllQueueRoiWithStats", startDate, endDate, {}, { databaseDisplayName });
}
